import { render, staticRenderFns } from "./TouchButtonGroup.vue?vue&type=template&id=6e8a624f&scoped=true"
import script from "./TouchButtonGroup.vue?vue&type=script&lang=js"
export * from "./TouchButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./TouchButtonGroup.vue?vue&type=style&index=0&id=6e8a624f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a624f",
  null
  
)

export default component.exports